export default "__VITE_ASSET__c27f1d45__"